import { render, staticRenderFns } from "./EditAccumulatedRechargeRebateDialog.vue?vue&type=template&id=5620d48c&scoped=true"
import script from "./EditAccumulatedRechargeRebateDialog.vue?vue&type=script&lang=js"
export * from "./EditAccumulatedRechargeRebateDialog.vue?vue&type=script&lang=js"
import style0 from "./EditAccumulatedRechargeRebateDialog.vue?vue&type=style&index=0&id=5620d48c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5620d48c",
  null
  
)

export default component.exports